import { useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, CreditCard, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const CardAddedPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />

      <section className="pt-32 pb-20">
        <div className="section-container">
          <div className="max-w-lg mx-auto">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              className="glass-card p-8 text-center"
            >
              <div className="w-20 h-20 bg-lime-400 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle2 className="w-10 h-10 text-emerald-950" />
              </div>
              <h1 className="heading-3 text-emerald-950 mb-4">Card Saved Successfully!</h1>
              <p className="text-stone-600 mb-8">
                Your card has been securely saved. You can now use it for faster checkout on future bookings.
              </p>

              <div className="bg-emerald-950 rounded-2xl p-6 mb-8">
                <div className="flex items-center gap-3 mb-2">
                  <CreditCard className="w-5 h-5 text-lime-400" />
                  <span className="text-white font-medium">Payment Method Added</span>
                </div>
                <p className="text-stone-400 text-sm">
                  Your card is now available for quick payments
                </p>
              </div>

              <div className="flex flex-col gap-3">
                <Link to="/">
                  <Button className="btn-primary w-full">
                    <Home className="w-4 h-4 mr-2" />
                    Back to Home
                  </Button>
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CardAddedPage;
